import {createSlice} from "@reduxjs/toolkit";
import {ResponseApi} from '../BaseApi';
import {CreateAttendanceShift, UpdateAttendanceShift} from './AttendanceShiftApi';

const AttendanceShiftSlice = createSlice({
    name: "attendanceShift",
    initialState: {
        addEdit: null
    },
    reducers: {
        resetAddEdit: (state, action) => {
            state.addEdit = null;
        }
    },
    extraReducers: (builder) => {
        builder.
        addCase(CreateAttendanceShift.fulfilled, (state, {payload}) =>{
            state.addEdit = ResponseApi(payload);
        }).addCase(UpdateAttendanceShift.fulfilled, (state, {payload}) =>{
            state.addEdit = ResponseApi(payload);
        })
    }

})

export const { resetAddEdit } = AttendanceShiftSlice.actions;

export default AttendanceShiftSlice.reducer;
